/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { useEffect } from 'react'
import Lenis from 'lenis'
import { frame } from './state.ts'

// Lenis damped scroll -> normalized targetP. The scrollbar tells the truth
// (PHILOSOPHY §5: not scroll-jacked); Lenis only smooths, never traps.
export function ScrollDriver() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true })
    let raf = 0
    const loop = (time: number) => {
      lenis.raf(time)
      raf = requestAnimationFrame(loop)
    }
    raf = requestAnimationFrame(loop)

    const update = () => {
      const limit = Math.max(1, document.body.scrollHeight - globalThis.innerHeight)
      frame.targetP = Math.min(1, Math.max(0, lenis.scroll / limit))
    }
    lenis.on('scroll', update)
    update()

    return () => {
      cancelAnimationFrame(raf)
      lenis.destroy()
    }
  }, [])
  return null
}
